<template>
  <div class="body">
    <div id="allmap"></div>
    <van-nav-bar title="收货地址" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content animated fadeInRight fast" v-if="hasData">
      <div
        class="itemWrap"
        v-for="item in list"
        :key="item.address_id"
        @click="selAddress(item.id)"
      >
        <div class="itemLeft">
          <div class="info">
            <p class="name">{{item.name}}</p>
            <p class="detail">{{item.phone}}</p>
            <p class="detail">{{item.address}}</p>
            <p class="distance">
              <i class="iconfont icon-map"/>
              {{item.distance}}
            </p>
          </div>
        </div>
        <div class="itemRight">
          <i class="iconfont icon-check" v-if="item.id==shopid"/>
        </div>
      </div>
    </div>
    <div v-if="!hasData">
      <NoData msg="亲，还没有自提店地址"/>
    </div>
    <iframe
      id="geoPage"
      width="0"
      height="0"
      frameborder="0"
      style="display:none;"
      scrolling="no"
      src="https://apis.map.qq.com/tools/geolocation?key=XFLBZ-QJPLF-4YOJU-JH6L5-KU57Q-ZTBI3&referer=gemts"
    ></iframe>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import { GetShop } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
import { RadioGroup, Radio, Dialog } from "vant";
import Vue from "vue";

Vue.use(RadioGroup)
  .use(Radio)
  .use(Dialog);
export default {
  components: {
    NoData
  },
  data() {
    return {
      hasData: false,
      checked: true,
      checkId: 0,
      list: [],
      token: ""
    };
  },
  computed: {
    shopid: function() {
      return this.$store.state.system.shopid;
    }
  },
  created() {},
  activated() {
    var that = this;
    window.addEventListener(
      "message",
      function(event) {
        // 接收位置信息
        var loc = event.data;
        console.log("location", loc);
        if (loc != null && loc.lat != undefined && loc.lng != undefined) {
          that.GetShop(loc.lng, loc.lat, getLocalStorage("login_token"));
        }
      },
      false
    );
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetShop(lng, lat, token) {
      GetShop(lng, lat, token)
        .then(res => {
          let data = res.data.list;
          this.list = [];
          for (let i in data) {
            this.list.push({
              id: data[i].shop_id,
              name: data[i].shop_name,
              phone: data[i].phone,
              address:
                data[i].region.province +
                data[i].region.city +
                data[i].region.region +
                data[i].address,
              distance: data[i].distance_unit
            });
          }
          if (this.list.length > 0) {
            this.hasData = true;
          }
        })
        .catch(e => {});
    },
    selAddress(id) {
      this.$store.commit("SHOPID", id);
      setTimeout(() => {
        this.$router.go(-1);
      }, 0);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    margin-bottom: 46px;
    .itemWrap {
      padding: 10px;
      background: @white;
      margin-bottom: 12px;
      display: flex;
      .itemLeft {
        padding-bottom: 5px;
        flex: 1 1 auto;
        .info {
          .name {
            font-size: 16px;
            color: @text;
            margin-bottom: 5px;
          }
          .detail {
            font-size: 14px;
            color: @lightP;
          }
          .distance {
            margin-top: 5px;
            font-size: 12px;
            color: @lightP;
          }
        }
      }
      .itemRight {
        width: 40px;
        overflow: hidden;
        text-align: center;
        padding: 20px 0px;
        i {
          font-size: 20px;
          color: @text;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 46px;
    z-index: 11;
    box-shadow: 1px 5px 15px rgba(50, 50, 50, 0.3);
    background: @white;
  }
  .addNew {
    width: 100%;
    // background: linear-gradient(to right, #fa1e8c 0, #fc1e56 100%);
    background: @btn;
    border: 0px;
    color: @white;
    text-align: center;
    line-height: 46px;
    font-size: 14px;
    height: 46px;
    float: left;
  }
}
</style>